var map = {
	"./404_2.svg": 99032,
	"./about.svg": 6848,
	"./add.svg": 24402,
	"./amount.svg": 78469,
	"./android.svg": 34806,
	"./archive.svg": 98121,
	"./baidu.svg": 16998,
	"./bili.svg": 43335,
	"./bozhu.svg": 22771,
	"./car.svg": 96705,
	"./category.svg": 47077,
	"./chrome.svg": 99783,
	"./contactUsTitle.svg": 8207,
	"./copyright.svg": 35848,
	"./csdn.svg": 82825,
	"./edge.svg": 10522,
	"./edit.svg": 95869,
	"./email.svg": 39083,
	"./empty.svg": 27680,
	"./feedback.svg": 65976,
	"./friendLink.svg": 84361,
	"./gitee.svg": 84041,
	"./github.svg": 60200,
	"./home.svg": 49504,
	"./hot.svg": 51542,
	"./hot2.svg": 76536,
	"./level1.svg": 98354,
	"./link.svg": 81445,
	"./mac.svg": 25570,
	"./message.svg": 38166,
	"./navication.svg": 21019,
	"./notice.svg": 89881,
	"./photo.svg": 36743,
	"./qq.svg": 75951,
	"./qqgroup.svg": 76604,
	"./safari.svg": 34353,
	"./say.svg": 47770,
	"./shandian.svg": 7181,
	"./shoufei.svg": 25268,
	"./sign1.svg": 56311,
	"./tag.svg": 1163,
	"./tianping.svg": 91557,
	"./topNotice.svg": 70550,
	"./wechat.svg": 80719,
	"./weibo.svg": 14003,
	"./wenhao.svg": 26019,
	"./windowns.svg": 76228,
	"./xiangqing.svg": 93111,
	"./xkxy.svg": 58331,
	"./yuan.svg": 30102,
	"./yuanchuang.svg": 33308,
	"./zhihu.svg": 50229,
	"./zzlink.svg": 29653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;